module.exports = __webpack_public_path__ + "img/404.3207e75d.png";